import { initializeApp } from "firebase/app";
import { getRemoteConfig, isSupported } from "firebase/remote-config";

export const firebaseConfig = {
  apiKey: process.env.firebase_api_key ?? "",
  authDomain: process.env.firebase_auth_domain ?? "",
  projectId: process.env.firebase_project_id ?? "",
  storageBucket: process.env.firebase_storage_bucket ?? "",
  messagingSenderId: "573206307383",
  appId: process.env.firebase_app_id ?? "",
};

// Call by await remoteConfig() every time a Remote Config instance is needed
export const remoteConfig = async () => {
  // Check if Remote Config is supported first
  const supported = await isSupported();
  if (!supported) {
    console.warn("Firebase Remote Config is not supported");
    return null;
  }

  const app = initializeApp(firebaseConfig);
  return getRemoteConfig(app);
};
